import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useNavigate, NavLink } from 'react-router-dom';
import Sidebar from './Sidebar'
import { country_code_array } from '../functions';
import { Helmet } from 'react-helmet';
import BACKEND_URL from '../../../api';

export default function Add_address() {

    const SERVER_URL = process.env.REACT_APP_SERVER_URL;
    const navigate = useNavigate()
    const userid = sessionStorage.getItem('userid')
    const [countries, setcountries] = useState(country_code_array);
    const [collectionDetails, setcollectionDetails] = useState({
        country: 'AE',
        name: 'xx',
        zip_code: ''
    })
    const [collectionaddress, setcollectionaddress] = useState()
    const [editcollectionaddress, seteditcollectionaddress] = useState()
    const [collectioncount, setcollectioncount] = useState()
    const [editform, seteditform] = useState(false)
    const [addform, setaddform] = useState(false)
    const [addressdisplay, setaddressdisplay] = useState(true)
    const [editformdelivery, seteditformdelivery] = useState(false)
    const [addformdelivery, setaddformdelivery] = useState(false)
    const [addressdisplaydelivery, setaddressdisplaydelivery] = useState(true)
    const [isOpen, setIsOpen] = useState(false);

    const toggleSidebar = () => {
        setIsOpen(!isOpen);
    };

    function showaddressform(val) {
        if (val == 'collection') {
            setaddform(true)
            seteditform(false)
            setaddressdisplay(false)
            setaddressdisplaydelivery(false)
        } else {
            setaddformdelivery(true)
            seteditformdelivery(false)
            setaddressdisplaydelivery(false)
            setaddressdisplay(false)
        }

    }

    function savecollection() {
        fetch(`${BACKEND_URL}/saveAddress`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                user: userid,
                collectionDetails: collectionDetails,
                type: 'delivery',
                postType: ''
            }),
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json(); // Parse the JSON response
            })
            .then((data) => {
                console.log(data);
                navigate('/my-account/address-book'); // Navigate to the address book
            })
            .catch(err => console.log(err));
    }

    useEffect(() => {
        fetch(`${BACKEND_URL}/getAddress`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                userid: userid
            }), // Convert userid to a JSON string
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json(); // Parse the JSON response
            })
            .then((data) => {
                setcollectionaddress(data.collection); // Update the state with the collection data
                setcollectioncount(data.collection.length); // Update the count of collection items
            })
            .catch(err => console.log(err)); // Log any errors
    }, [])

    function editAddress(val, type) {
        setcollectionDetails(val)
        if (type == 'collection') {

            seteditform(true)
            setaddform(false)
            setaddressdisplay(false)
            seteditformdelivery(false)
            setaddressdisplaydelivery(false)

        } else {
            setaddformdelivery(false)
            seteditformdelivery(true)
            setaddressdisplaydelivery(false)
            seteditform(false)
        }

    }

    return (


        <div className="wallet-plan addressbook">
            <Helmet>
                <title>Shypv | Address Book</title>
            </Helmet>
            <div className="myparctab" style={{ padding: "0" }} >

                <div className="container-fluid" style={{ padding: "0" }}>
                    <div className="row1">

                        <Sidebar isOpen={isOpen} />
                        <div id="admin-main-control" className="col-md-9 p-x-3 p-y-1" style={{ overflow: "auto", backgroundColor: "#f1f5f9" }}>

                            {/* Add Collection Address */}

                            <div className="col-md-12 col-sm-12 col-xs-12">	    
                                <div style={{ boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)" }}>
                                    <nav className="navbar navbar-expand-lg navbar-light bg-light">
                                        <div className="container-fluid" style={{ justifyContent: "space-between" }}>
                                            <button className="navbar-toggler" type="button" onClick={toggleSidebar}>
                                                {
                                                    isOpen ? (
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="32"
                                                            height="32"
                                                            className="bi bi-arrow-bar-left"
                                                            viewBox="0 0 16 16"
                                                        >
                                                            <path
                                                                fillRule="evenodd"
                                                                d="M12.5 15a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 1 0v13a.5.5 0 0 1-.5.5M10 8a.5.5 0 0 1-.5.5H3.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L3.707 7.5H9.5a.5.5 0 0 1 .5.5"
                                                            />
                                                        </svg>
                                                    ) : (
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="32"
                                                            height="32"
                                                            className="bi bi-arrow-bar-right"
                                                            viewBox="0 0 16 16"
                                                        >
                                                            <path
                                                                fillRule="evenodd"
                                                                d="M6 8a.5.5 0 0 0 .5.5h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L12.293 7.5H6.5A.5.5 0 0 0 6 8m-2.5 7a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 1 0v13a.5.5 0 0 1-.5.5"
                                                            />
                                                        </svg>
                                                    )
                                                }
                                            </button>
                                            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                                                <span className="navbar-toggler-icon"></span>
                                            </button>
                                            <div className="offset-1 collapse navbar-collapse" id="navbarNav">
                                                <ul className="navbar-nav">
                                                    <>
                                                        <li className="nav-item">
                                                            <NavLink activeclassname="active" exact to="/">HOME</NavLink>
                                                            {/* <Link className="nav-link active"  aria-current="page" exact  to="/">HOME  </Link> */}
                                                        </li>
                                                        <li className="nav-item">
                                                            <NavLink exact to="/track">TRACK</NavLink>
                                                            {/* <Link className="nav-link" exact  to="/track">TRACK</Link> */}
                                                        </li>

                                                        {/* <li className="nav-item">
                                                            <NavLink exact to="/smart-send">SMART SEND</NavLink>
                                                        </li>
                                                        <li className="nav-item">
                                                            <NavLink exact to="/your-business">YOUR BUSINESS</NavLink>
                                                        </li>
                                                        <li className="nav-item">
                                                            <NavLink exact to="/help">HELP</NavLink>
                                                        </li>
                                                        <li className="nav-item">
                                                            <NavLink exact to="/become-a-partner">PARTNERS</NavLink>
                                                        </li>
                                                        <li className="nav-item">
                                                            <NavLink exact to="/parcels-on-demand">HOW IT WORKS</NavLink>
                                                        </li>
                                                        <li className="nav-item">
                                                            <a href="https://www.tymexlogistics.com/" target="_blank">LOGISTICS</a>
                                                        </li>
                                                        <li className="nav-item">
                                                            <NavLink exact to="/client-zone">CLIENT ZONE</NavLink>
                                                        </li> */}
                                                    </>
                                                </ul>
                                            </div>
                                        </div>
                                    </nav>
                                </div>

                                <div style={{ margin: "20px", padding: "20px", backgroundColor: "white", boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)" }}>
                                    <h3 className="panel-title comaprison_hedding" style={{ padding: "2%", background: "#f5f5f5" }}>Delivery Address</h3>


                                    <form>
                                        <div className="row" style={{ marginLeft: "15px", marginRight: "15px" }}>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label htmlFor="exampleInputEmail1">Name<span className="required">*</span></label>
                                                    <input type="text" className="form-control" name="collection_name" onChange={(e) => setcollectionDetails({ ...collectionDetails, name: e.target.value })} id="collection_name" maxLength={50} placeholder="Name" />
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label htmlFor="exampleInputEmail1">Email<span className="required">*</span></label>
                                                    <input type="text" className="form-control" name="collection_email" onChange={(e) => setcollectionDetails({ ...collectionDetails, email: e.target.value })} id="collection_email" placeholder="Email" />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label htmlFor="exampleInputEmail1">Phone<span className="required">*</span></label>
                                                    <div className="input-group new-group">
                                                        <div className="input-group-addon" style={{ paddingTop: "6%" }}></div>
                                                        <input type="text" className="form-control" name="collection_phone" id="collection_phone" onChange={(e) => setcollectionDetails({ ...collectionDetails, phone: e.target.value })} placeholder="Phone" style={{ margin: 0 }} />
                                                        <input type="hidden" name="collection_phone_code" id="collection_phone_code" defaultValue="" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row" style={{ marginLeft: "15px", marginRight: "15px" }}>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label htmlFor="exampleInputEmail1">Address</label>
                                                    <input type="text" className="form-control" name="collection_address" onChange={(e) => setcollectionDetails({ ...collectionDetails, address: e.target.value })} id="collection_address" placeholder="Address" />
                                                </div>
                                            </div>

                                            <div className="col-md-8">
                                                <div className="row">
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="exampleInputEmail1">City/Town</label>
                                                            <input type="text" className="form-control" name="collection_city" onChange={(e) => setcollectionDetails({ ...collectionDetails, city: e.target.value })} id="collection_city" placeholder="City/Town" />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-5">
                                                        <div className="form-group">
                                                            <label htmlFor="exampleInputEmail1">Country<span className="required">*</span></label>

                                                            <select className="form-select select-export-package" name="delivery_to" value={collectionDetails.country} onChange={(e) => setcollectionDetails({ ...collectionDetails, country: e.target.value })}>
                                                                {

                                                                    Object.entries(countries).map(([k, v]) => (
                                                                        <option key={k} value={k} >{v}</option>
                                                                    ))
                                                                }

                                                            </select>

                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label htmlFor="exampleInputEmail1">Zipcode</label>
                                                            <input type="text" className="form-control cd" name="collection_zipcode" onChange={(e) => setcollectionDetails({ ...collectionDetails, zip_code: e.target.value })} id="collection_zipcode" placeholder="Zipcode" />
                                                        </div>
                                                    </div>


                                                </div>
                                            </div>

                                            <div className="col-md-12 col-sm-12 text-right" >
                                                <input type="button" defaultValue="Submit" name="save" onClick={savecollection} className="btn btn-success pull-right" id="save" style={{ float: "right", margin: "3%", backgroundColor: "#3c50e0" }} />
                                            </div>
                                        </div>

                                    </form>
                                </div>
                            </div>
                            {/* Edit Collection Address */}


                        </div>



                    </div>










                </div>


            </div>
        </div>






    )
}
